import { render, staticRenderFns } from "./product-brother.vue?vue&type=template&id=c38e5faa&"
import script from "./product-brother.vue?vue&type=script&lang=js&"
export * from "./product-brother.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports